<template>
  <div class="lv-upload-img-with-preview">
    <LvText v-if="title" h6 bold>{{ $t(title) }}</LvText>
    <div
      class="lv-upload-img-with-preview__image"
      :style="{ backgroundImage: 'url(' + url + ')' }"
      :class="{ blue }"
    >
      <div class="lv-upload-img-with-preview__upload-wrap">
        <LvUploadImgBtn
          big
          oneFile
          isTextBtn
          :uploadText="uploadText"
          :leadingIcon="leadingIcon"
          :uploadModule="uploadModule"
          class="lv-upload-img-with-preview__upload-btn"
          @input="$_onAttachImgs($event)"
        />
        <div class="lv-upload-img-with-preview__icon">
          <i
            v-if="showDownloadBtn && hasScope"
            class="icon icon-cloud-download"
            @click.stop="$_onDownload(url)"
          />
          <i
            v-if="showDeleteBtn && hasScope"
            class="icon icon-cancel"
            @click.stop="$_onClickDelete()"
          />
          <i v-if="showMoreBtn & hasScope" class="icon icon-more" @click.stop="$_onClickMore()" />
        </div>
        <div class="lv-upload-img-with-preview__upload-bg" />
      </div>
    </div>
    <LvPopupDeleteFile
      ref="LvPopupDeleteFile"
      :id="id"
      :module="uploadModule"
      :isSystem="isSystem"
      @remove="$emit('remove')"
    />
  </div>
</template>
<script>
import S_file from '@/service/api/v1/file';

export default {
  props: {
    url: {
      type: String,
    },
    blue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    uploadText: {
      type: String,
      default: '上傳',
    },
    leadingIcon: {
      type: String,
      default: 'icon-photo',
    },
    uploadModule: {
      type: String,
    },
    showDownloadBtn: {
      type: Boolean,
      default: true,
    },
    showMoreBtn: {
      type: Boolean,
      default: false,
    },
    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
    hasScope: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    isSystem: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
    },
    fileType: {
      type: String,
    },
  },
  methods: {
    $_onAttachImgs($event) {
      this.$emit('input', $event);
    },
    $_onClickMore() {
      this.$emit('go-to');
    },
    async $_onDownload(url) {
      if (!url || !this.name || !this.fileType) {
        this.$store.dispatch('downloadPopup/open');
        this.$store.dispatch('downloadPopup/showError', '下載失敗，請稍後再試');
        return;
      }
      await S_file.download(url, this.name, this.fileType);
    },
    async $_onClickDelete() {
      await this.$refs.LvPopupDeleteFile.$_onOpenPopup('popup');
    },
  },
};
</script>
